// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubProfileCard-cls1___8a3d13e7b0ef75c997b","cls2":"ImpactHubProfileCard-cls2___6d776367d89c5df54e8 ImpactHubProfileCard-cls1___8a3d13e7b0ef75c997b"};